import { render, staticRenderFns } from "./CourseraCollection.vue?vue&type=template&id=fa42fc30&scoped=true&"
import script from "./CourseraCollection.vue?vue&type=script&lang=ts&"
export * from "./CourseraCollection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa42fc30",
  null
  
)

export default component.exports